import { ifUserHasAccess } from "../guards";

const route = [
  {
    path: "/fornecedor/customizacao/textos-estaticos",
    name: "Textos estáticos",
    beforeEnter: ifUserHasAccess,
    component: () =>
      import("@/pages/customizacao/texto-estatico/TextosEstaticos"),
    meta: {
      header: {
        title: "Textos estáticos",
        subtitle:
          "Use essa área para editar os textos estáticos do seu e-commerce",
        breadcrumb: [
          { text: "Início", route: "/" },
          {
            text: "Textos estáticos",
            route: "/fornecedor/customizacao/textos-estaticos"
          }
        ]
      }
    }
  },
  {
    path: "/fornecedor/customizacao/carrossel",
    name: "Carrossel",
    beforeEnter: ifUserHasAccess,
    component: () => import("@/pages/customizacao/carrossel/Carrossel.vue"),
    meta: {
      header: {
        title: "Gestão de Carrosséis",
        subtitle: "Crie, edite e gerencie os carrosséis exibidos no site.",
        breadcrumb: [
          { text: "Início", route: "/" },
          {
            text: "Gestão de Carrosséis",
            route: "/fornecedor/customizacao/carrossel"
          }
        ]
      }
    }
  },
  {
    path: "/fornecedor/customizacao/carrossel/criar",
    name: "Novo carrossel",
    beforeEnter: ifUserHasAccess,
    component: () =>
      import("@/pages/customizacao/carrossel/CarrosselWizard.vue"),
    meta: {
      listRoute: "/fornecedor/customizacao/carrossel",
      header: {
        title: "Novo carrossel",
        subtitle: "Crie um novo carrossel e defina as configurações iniciais.",
        breadcrumb: [
          { text: "Início", route: "/" },
          {
            text: "Gestão de Carrosséis",
            route: "/fornecedor/customizacao/carrossel"
          },
          {
            text: "Novo carrossel",
            route: "/fornecedor/customizacao/carrossel/criar"
          }
        ]
      }
    }
  },
  {
    path: "/fornecedor/customizacao/carrossel/editar/:idcarrossel",
    name: "Editar carrossel",
    beforeEnter: ifUserHasAccess,
    component: () =>
      import("@/pages/customizacao/carrossel/CarrosselWizard.vue"),
    meta: {
      listRoute: "/fornecedor/customizacao/carrossel",
      header: {
        title: "Editar carrossel",
        subtitle: "Edite as informações e banners do carrossel.",
        breadcrumb: [
          { text: "Início", route: "/" },
          {
            text: "Gestão de Carrosséis",
            route: "/fornecedor/customizacao/carrossel"
          },
          {
            text: "Editar carrossel",
            route: "/fornecedor/customizacao/carrossel/editar"
          }
        ]
      }
    }
  },
  {
    path: "/fornecedor/customizacao/vitrine-produto",
    name: "Vitrine",
    beforeEnter: ifUserHasAccess,
    component: () => import("@/pages/customizacao/vitrine/VitrineTemplate.vue"),
    meta: {
      header: {
        title: "Gestão de Vitrines",
        subtitle:
          "Crie, edite e gerencie as vitrines de produtos exibidas no site.",
        breadcrumb: [
          { text: "Início", route: "/" },
          {
            text: "Gestão de Vitrines",
            route: "/fornecedor/customizacao/vitrine-produto"
          }
        ]
      }
    }
  },
  {
    path: "/fornecedor/customizacao/vitrine-produto/criar",
    name: "Nova vitrine",
    beforeEnter: ifUserHasAccess,
    component: () => import("@/pages/customizacao/vitrine/VitrineWizard.vue"),
    meta: {
      listRoute: "/fornecedor/customizacao/vitrine-produto",
      header: {
        title: "Nova vitrine",
        subtitle: "Crie uma nova vitrine e defina as configurações iniciais.",
        breadcrumb: [
          { text: "Início", route: "/" },
          {
            text: "Gestão de Vitrines",
            route: "/fornecedor/customizacao/vitrine-produto"
          },
          {
            text: "Nova vitrine",
            route: "/fornecedor/customizacao/vitrine-produto/criar"
          }
        ]
      }
    }
  },
  {
    path: "/fornecedor/customizacao/vitrine-produto/editar/:idcarrossel",
    name: "Editar vitrine",
    beforeEnter: ifUserHasAccess,
    component: () => import("@/pages/customizacao/vitrine/VitrineWizard.vue"),
    meta: {
      listRoute: "/fornecedor/customizacao/vitrine-produto",
      header: {
        title: "Editar vitrine",
        subtitle: "Edite as informações e configurações da vitrine.",
        breadcrumb: [
          { text: "Início", route: "/" },
          {
            text: "Gestão de Vitrines",
            route: "/fornecedor/customizacao/vitrine-produto"
          },
          {
            text: "Editar vitrine",
            route: "/fornecedor/customizacao/vitrine-produto/editar"
          }
        ]
      }
    }
  }
];

export default route;
